import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "quoteleft" }
const _hoisted_4 = {
  key: 0,
  id: "createaccount"
}
const _hoisted_5 = { class: "fieldleft" }
const _hoisted_6 = { class: "fieldright" }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = { class: "fieldleft" }
const _hoisted_9 = { class: "fieldright" }
const _hoisted_10 = {
  key: 1,
  id: "loginaccount"
}
const _hoisted_11 = { class: "fieldleft" }
const _hoisted_12 = { class: "fieldright" }
const _hoisted_13 = { style: {"text-align":"center"} }

import QuoteCart from "@/views/quote/QuoteCart.vue";
import { User } from "@/models/User";
import { UserData } from "@/api/UserData";
import Loader from "@/components/MainLoader.vue";
import StatusComponent from "@/components/StatusComponent.vue";
import ValidationError from "@/components/ValidationError.vue";
import { onMounted, ref, computed, Ref, ComputedRef } from "vue";
import { useUserStore } from "@/stores/root/users";
import { useQuoteStore } from "@/stores/root/quote";
import { scrollMeTo, stat } from "@/utils/Utils";
import { useStatusStore } from "@/stores/root/status";

import { useReCaptcha } from "vue-recaptcha-v3";

export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteAccount',
  setup(__props) {

const createAccount: Ref<boolean> = ref(true);
const loading: Ref<boolean> = ref(false);
const userStore = useUserStore();
const quote = useQuoteStore();
const currentUser = ref(new User());
const validationErrors: Ref<any[]> = ref([]);
const user = userStore.user;
const statusStore = useStatusStore();

//we need token for reCaptcha on register
const gReCaptcha = useReCaptcha();
const captchaToken = ref();
const insertRecaptchaToken = async () => {
  // (optional) Wait until recaptcha has been loaded.
  await gReCaptcha?.recaptchaLoaded();

  // Execute reCAPTCHA with action "login".
  captchaToken.value = await gReCaptcha?.executeRecaptcha("login");
  localStorage.setItem("rToken", captchaToken.value);
};

onMounted(async () => {
  if (user.loggedIn) {
    quote.setQuoteStep("quote-checkout");
    return;
  }
  loading.value = true;
  stat(statusStore).clear;
  loading.value = false;
});

function validatePasswordCriteria(): boolean {
  if (
    currentUser.value.password.match(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{6,}$/
    )
  ) {
    return true;
  }
  return false;
}
const validate: ComputedRef<boolean> = computed(() => {
  if (createAccount.value) {
    return (
      currentUser.value.email.length > 0 &&
      currentUser.value.firstName.length > 0 &&
      currentUser.value.lastName.length > 0 &&
      currentUser.value.password.length > 0 &&
      currentUser.value.password == currentUser.value.confirmPassword &&
      validatePasswordCriteria()
    );
  } else {
    return (
      currentUser.value.email.length > 0 &&
      currentUser.value.password.length > 0
    );
  }
});
function createValidationMessages(): void {
  validationErrors.value.length = 0;
  if (createAccount.value) {
    if (!currentUser.value.email) {
      const error = {
        name: "email",
        value: "Email is required.",
      };
      validationErrors.value.push(error);
    }
    if (!currentUser.value.firstName) {
      const error = {
        name: "firstName",
        value: "First name is required.",
      };
      validationErrors.value.push(error);
    }
    if (!currentUser.value.lastName) {
      const error = {
        name: "lastName",
        value: "Last name is required.",
      };
      validationErrors.value.push(error);
    }
    const hasPassword = currentUser.value.password;
    if (!hasPassword) {
      const error = {
        name: "password",
        value: "Password is required.",
      };
      validationErrors.value.push(error);
    } else {
      if (!validatePasswordCriteria()) {
        const error = {
          name: "password",
          value:
            "Invalid password. Minimum 6 characters: number(s), lowercase, uppercase, and special character(s) required",
        };
        validationErrors.value.push(error);
      }
    }
    if (!currentUser.value.confirmPassword) {
      const error = {
        name: "confirmPassword",
        value: "Password confirmation is required.",
      };
      validationErrors.value.push(error);
    } else {
      if (currentUser.value.password != currentUser.value.confirmPassword) {
        const error = {
          name: "confirmPassword",
          value: "Password mismatch.",
        };
        validationErrors.value.push(error);
      }
    }
  } // login account
  else {
    if (!currentUser.value.email) {
      const error = {
        name: "loginEmail",
        value: "Email is required.",
      };
      validationErrors.value.push(error);
    }
    if (!currentUser.value.password) {
      const error = {
        name: "loginPassword",
        value: "Password is required.",
      };
      validationErrors.value.push(error);
    }
  }
}

async function goToPage(command: string) {
  stat(statusStore).clear;
  if (!validate.value) {
    createValidationMessages();
    stat(statusStore).error("Please fill in required fields.");
    scrollMeTo("status");
    return;
  }
  loading.value = true;
  let doLogin = false;

  if (createAccount.value) {
    await insertRecaptchaToken();
    const result = await UserData.createUser(
      currentUser.value.email,
      currentUser.value.password,
      currentUser.value.firstName,
      currentUser.value.lastName
    );
    if (result.error) {
      stat(statusStore).error(result.message);
      scrollMeTo("status");
      loading.value = false;
      return;
    } else {
      await UserData.login(currentUser.value.email, currentUser.value.password);
      doLogin = true;
    }
  } else {
    doLogin = true;
  }
  if (doLogin) {
    const loginResult = await UserData.login(
      currentUser.value.email,
      currentUser.value.password
    );
    if (loginResult.error) {
      stat(statusStore).error(loginResult.message);
      scrollMeTo("status");
      loading.value = false;
      return;
    }
  }
  loading.value = false;
  quote.setQuoteStep(command);
}
function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
  if (!validationErrors.value.length) {
    stat(statusStore).clear;
  }
}
function validatedFieldChanged(event: any): void {
  clearValidationMessage(event.target.name);
}
function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Loader, { loading: loading.value }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (createAccount.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "title" }, "Create Account", -1)),
              _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
              _createVNode(StatusComponent),
              _cache[19] || (_cache[19] = _createTextVNode(" Register to save time in the future. Already have a NSSI account? ", -1)),
              _createElementVNode("a", {
                class: "actionlink",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (createAccount.value = false), ["prevent"]))
              }, " Login here. "),
              _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
              _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
              _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('firstName') }])
                }, [...(_cache[10] || (_cache[10] = [
                  _createTextVNode(" First Name ", -1),
                  _createElementVNode("red", null, "*", -1)
                ]))], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentUser.value.firstName) = $event)),
                  type: "text",
                  name: "firstName",
                  class: _normalizeClass({ validationfield: hasErrors('firstName') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, currentUser.value.firstName]
                ]),
                _createVNode(ValidationError, {
                  name: "firstName",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('lastName') }])
                }, [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Last Name ", -1),
                  _createElementVNode("red", null, "*", -1)
                ]))], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentUser.value.lastName) = $event)),
                  type: "text",
                  name: "lastName",
                  class: _normalizeClass({ validationfield: hasErrors('lastName') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, currentUser.value.lastName]
                ]),
                _createVNode(ValidationError, {
                  name: "lastName",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('email') }])
                }, [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" Email ", -1),
                  _createElementVNode("red", null, "*", -1)
                ]))], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentUser.value.email) = $event)),
                  type: "text",
                  name: "email",
                  class: _normalizeClass({ validationfield: hasErrors('email') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, currentUser.value.email]
                ]),
                _createVNode(ValidationError, {
                  name: "email",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("div", { style: {"clear":"both"} }, null, -1)),
              _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
              _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('password') }])
                }, [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" Create Password ", -1),
                  _createElementVNode("red", null, "*", -1)
                ]))], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentUser.value.password) = $event)),
                  type: "password",
                  name: "password",
                  class: _normalizeClass({ validationfield: hasErrors('password') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, currentUser.value.password]
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("hint", null, " Minimum 6 characters: number(s), lowercase, uppercase, and character(s) required. ", -1)),
                _createVNode(ValidationError, {
                  name: "password",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('confirmPassword') }])
                }, [...(_cache[15] || (_cache[15] = [
                  _createTextVNode(" Confirm Password ", -1),
                  _createElementVNode("red", null, "*", -1)
                ]))], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentUser.value.confirmPassword) = $event)),
                  type: "password",
                  name: "confirmPassword",
                  class: _normalizeClass({ validationfield: hasErrors('confirmPassword') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, currentUser.value.confirmPassword]
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("hint", null, " Minimum 6 characters: number(s), lowercase, uppercase, and character(s) required. ", -1)),
                _createVNode(ValidationError, {
                  name: "confirmPassword",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[29] || (_cache[29] = _createElementVNode("div", { class: "title" }, "Login", -1)),
              _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
              _cache[31] || (_cache[31] = _createTextVNode(" Log into your NSSI account. ", -1)),
              _createElementVNode("a", {
                class: "actionlink",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (createAccount.value = true), ["prevent"]))
              }, " Or create an account. "),
              _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
              _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
              _createVNode(StatusComponent),
              _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('loginEmail') }])
                }, [...(_cache[27] || (_cache[27] = [
                  _createTextVNode(" Email Address ", -1),
                  _createElementVNode("red", null, "*", -1)
                ]))], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentUser.value.email) = $event)),
                  type: "text",
                  name: "loginEmail",
                  class: _normalizeClass({ validationfield: hasErrors('loginEmail') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, currentUser.value.email]
                ]),
                _createVNode(ValidationError, {
                  name: "loginEmail",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", {
                  class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('loginPassword') }])
                }, [...(_cache[28] || (_cache[28] = [
                  _createTextVNode(" Password ", -1),
                  _createElementVNode("red", null, "*", -1)
                ]))], 2),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentUser.value.password) = $event)),
                  type: "password",
                  name: "loginPassword",
                  class: _normalizeClass({ validationfield: hasErrors('loginPassword') }),
                  onInput: validatedFieldChanged
                }, null, 34), [
                  [_vModelText, currentUser.value.password]
                ]),
                _createVNode(ValidationError, {
                  name: "loginPassword",
                  errors: validationErrors.value
                }, null, 8, ["errors"])
              ])
            ])),
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "spacer" }, null, -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: _normalizeClass({ disabled: !validate.value }),
            onClick: _cache[9] || (_cache[9] = ($event: any) => (goToPage('quote-checkout')))
          }, " Continue ", 2)
        ]),
        _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
        _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
        _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
        _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
        _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
        _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1))
      ]),
      _createVNode(QuoteCart)
    ])
  ]))
}
}

})